import Script from "next/script";

const PROMPTWATCH_ID = process.env.NEXT_PUBLIC_PROMPTWATCH_ID;

export const PromptwatchScript = () => {
  if (!PROMPTWATCH_ID) {
    return null;
  }

  return (
    <Script
      src="https://ingest.promptwatch.com/js/client.min.js"
      data-project-id={PROMPTWATCH_ID}
    />
  );
};
